document.addEventListener("ShoptetDOMContentLoaded", function () {
  if ($(".cart-empty").length) {
    if (!$(".hpBannerTopCategories").length) {
      //    sessionStorage.removeItem('loadedCategories');
      //     sessionStorage.removeItem('loadedTopBrands');
      if (sessionStorage.homepageCategories && sessionStorage.homepageCategories !== "undefined") {
        $(".cart-inner.cart-empty").append('<div class="hpBannerTopCategories">' + sessionStorage.homepageCategories + "</div>");
        if (sessionStorage.homepageBrands && sessionStorage.homepageBrands !== "undefined") {
          $(".cart-inner.cart-empty").append('<div class="topBrands">' + sessionStorage.homepageBrands + "</div>");
        }
        slickItems();
      } else {
        // Jinak načti AJAXem
        $.ajax({
          type: "GET",
          dataType: "html",
          timeout: 10000,
          cache: true,
          url: "/",
          success: function (e) {
            var doc = shoptet.common.createDocumentFromString(e);

            // Kategorie
            var categoriesHtml = $(doc).find(".benefitBanner.position--benefitHomepage .hpBannerTopCategories").html();
            if (categoriesHtml) {
              $(".cart-inner.cart-empty").append('<div class="hpBannerTopCategories">' + categoriesHtml + "</div>");
              sessionStorage.homepageCategories = categoriesHtml;
            }

            // Značky
            var brandsHtml = $(doc).find(".benefitBanner.position--benefitHomepage .topBrands").html();
            if (brandsHtml) {
              $(".cart-inner.cart-empty").append('<div class="topBrands">' + brandsHtml + "</div>");
              sessionStorage.homepageBrands = brandsHtml;
            }

            slickItems();
          },
        });
      }
    } else {
      slickItems();
    }
  }
});

function slickItems() {
  $(".hpBannerCategoryList").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4.4, slidesToScroll: 1 } },
      { breakpoint: 992, settings: { slidesToShow: 3.4, slidesToScroll: 1 } },
      { breakpoint: 768, settings: "unslick" },
    ],
  });
  $(".topBrands .brandFeed").slick({
    slidesToShow: 10,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1440, settings: { slidesToShow: 10, slidesToScroll: 1 } },
      { breakpoint: 1200, settings: { slidesToShow: 8, slidesToScroll: 1 } },
      { breakpoint: 992, settings: { slidesToShow: 6, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 5, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 3.4, slidesToScroll: 1 } },
      { breakpoint: 340, settings: { slidesToShow: 2.4, slidesToScroll: 1 } },
    ],
  });
}

document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
  const $slider = $("#cboxContent #products");

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 550, settings: { slidesToShow: 1, variableWidth: true } },
    ],
  });

  $(window).trigger("resize");
  $slider.slick("setPosition");
});
